// src/components/Header.jsx — v9.7
// Forensic positioning update: "Campaign Failure Analysis" → "Forensic Failure Reconstruction"

export default function Header() {
  const now     = new Date();
  const dateStr = now.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });

  return (
    <header style={{
      height:         52,
      display:        "flex",
      alignItems:     "center",
      justifyContent: "space-between",
      padding:        "0 36px",
      background:     "var(--bg-secondary)",
      borderBottom:   "1px solid var(--border-subtle)",
      flexShrink:     0,
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{
          fontFamily:    "var(--font-mono)",
          fontSize:      11,
          color:         "var(--text-muted)",
          letterSpacing: "0.08em",
        }}>
          VIRAJ
        </span>
        <span style={{ color: "var(--text-tertiary)", opacity: 0.4 }}>·</span>
        <span style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--text-tertiary)" }}>
          Campaign failure analysis
        </span>
      </div>

      <span style={{ fontFamily: "var(--font-mono)", fontSize: 11, color: "var(--text-tertiary)" }}>
        {dateStr}
      </span>
    </header>
  );
}
